import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { accidentConfig } from './configByInsuranceType/accident';
import { carConfig } from './configByInsuranceType/car';
import { fundConfig } from './configByInsuranceType/fund';
import { healthConfig } from './configByInsuranceType/health';
import { legalConfig } from './configByInsuranceType/legal';
import { lifeConfig } from './configByInsuranceType/life';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: true,
    relyOnWebAPIAlias: true,
    showCurrentCapitalValue: false,
    claims: claimsConfig.AT,
    dashboard: dashboardConfig.AT,
    funds: fundsConfig.AT,
    modifications: modificationsConfig.AT,
    servicing: servicingConfig.AT,
    accident: accidentConfig.AT,
    car: carConfig.AT,
    fund: fundConfig.AT,
    health: healthConfig.AT,
    legal: legalConfig.AT,
    life: lifeConfig.AT,
    property: propertyConfig.AT,
    travel: travelConfig.AT,
};
